<div class="candidate-attribute {{ skill.matchLevel }}">
  <div class="name">{{ skill.name }}</div>
  <div *ngIf="skill.level" class="level">{{ skill.level }}</div>
</div>
